module.exports = __webpack_public_path__ + "img/orange.f2c31f48.png";